module.exports = __webpack_public_path__ + "static/image/font/pc/bmjua-3@3x.ver2_0_2.jpg?0889cf35";